import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';

import { AssemblyMemberPart } from '../../../../store/selectors/assemblyPartsUtilities';
import { BundleMemberPartEntry } from '../../../../store/selectors/getBundleAssemblyMemberPartEntriesByBundleGuid';
import { applyMemberFilter } from './applyMemberFilter';
import { AssemblyMemberPartDiagram } from './AssemblyMemberPartDiagram';
import { getMemberFilter, PartsFilterSelection } from './getMemberFilter';

interface BundlePartsTableProps {
  readonly bundleMemberParts: readonly BundleMemberPartEntry[];
  readonly partsFilterSelection: PartsFilterSelection;
  readonly showBundleIdHeader: boolean;
}

export function BundleAssemblyMemberPartDiagrams(props: BundlePartsTableProps) {
  const { bundleMemberParts, partsFilterSelection, showBundleIdHeader } = props;

  const memberFilter = useMemo(() => getMemberFilter(partsFilterSelection), [partsFilterSelection]);

  if (memberFilter === null) throw new Error('Trying to display member parts when a member filter is not selected');

  return (
    <>
      {bundleMemberParts.map((bundleMemberPartsGroup) => {
        const bundlePartsWithMemberFilterMatches: readonly AssemblyMemberPart[] = applyMemberFilter(
          bundleMemberPartsGroup.bundleAssemblyMemberParts,
          memberFilter,
        );
        return (
          <Box
            sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
            key={bundleMemberPartsGroup.bundleId}
          >
            {showBundleIdHeader && (
              <Typography variant="h4" sx={{ ml: 1 }}>
                Bundle {bundleMemberPartsGroup.bundleId}
              </Typography>
            )}
            {bundlePartsWithMemberFilterMatches.map(
              ({ guid, getStandardizedMemberPolygonAtOrigin, memberCuts, membersOfCutAndLength }) => (
                <AssemblyMemberPartDiagram
                  getStandardizedMemberPolygonAtOrigin={getStandardizedMemberPolygonAtOrigin}
                  memberCuts={memberCuts}
                  membersOfCutAndLength={membersOfCutAndLength}
                  key={guid}
                />
              ),
            )}
          </Box>
        );
      })}
    </>
  );
}
